// @flow
import * as React from 'react';
import { useContext } from 'react';
import ReviewSearch from 'containers/search/NativeReviews';
import MediaSearch from 'containers/search/Media';
import NetworkReviewSearch from 'containers/search/NetworkReviews';
import Page from 'pages/__components__/LandingPage';
import type { ContextRouter } from 'react-router-dom';
import UgcLinkContext from 'containers/UgcLinkContext';
import UgcAssignmentProvider from 'containers/client/UgcAssignmentProvider';
import ugcSearchParams from 'containers/search/SearchForm/ugcSearchQuery';
import ReviewChannels from './ReviewChannels';
import { ClientContentCardProvider } from 'context/content-card-context';
import { ClientContext } from 'containers/client/ClientProvider';
// Commenting out until this ugc type is supported
import {
  ReviewSearch as PwrDistroReviewSearch,
  // MediaSearch as PwrDistroMediaSearch,
} from 'containers/search/PwrDistribution';

const channelsRoute = {
  exact: false,
  path: 'channels',
  component: ReviewChannels,
  label: 'Channels',
  navItem: true,
};
const reviewSearchRoute = {
  exact: false,
  path: 'native-reviews',
  label: ReviewSearch.label,
  component: ReviewSearch,
  navItem: true,
};
const networkSearchRoute = {
  exact: false,
  path: 'network-reviews',
  label: NetworkReviewSearch.label,
  component: NetworkReviewSearch,
  navItem: true,
};
const mediaSearchRoute = {
  exact: false,
  path: 'images-and-video',
  label: MediaSearch.label,
  component: MediaSearch,
  navItem: true,
};

const allRoutes = [
  channelsRoute,
  reviewSearchRoute,
  networkSearchRoute,
  mediaSearchRoute,
];
const pwrDistroSearchRoutes = [
  channelsRoute,
  {
    exact: false,
    path: 'reviews-search',
    label: 'Reviews',
    component: PwrDistroReviewSearch,
    navItem: true,
  },
  'sep',
  reviewSearchRoute,
  networkSearchRoute,
  mediaSearchRoute,
];
const channelOnlySlice = [channelsRoute];

export const ugcSearchPathname = (ugc: Ugc): ?string => {
  if (ugc.ugc_archetype === 'Review') {
    return reviewSearchRoute.path;
  }

  if (ugc.ugc_archetype === 'Image' || ugc.ugc_archetype === 'Video') {
    return mediaSearchRoute.path;
  }

  return null;
};

// we do not support linking when running network searches...for now
const locationSupportsUgcLinking = (path: string) =>
  path.indexOf(networkSearchRoute.path) === -1;

const ReviewsIndex = (props: { ...UserInfo, ...ContextRouter }) => {
  const clientProps = useContext(ClientContext);
  let routes;
  if (
    clientProps &&
    (clientProps.clientId === 164195141 ||
      clientProps.clientId === 1986404165 ||
      clientProps.clientId === 380979969 ||
      clientProps.clientId === 12846 ||
      clientProps.clientId === 1901388221)
  ) {
    routes = pwrDistroSearchRoutes;
  } else if (props.access.search) {
    routes = allRoutes;
  } else {
    routes = channelOnlySlice;
  }
  const linkFn = locationSupportsUgcLinking(props.location.pathname)
    ? ugc => {
        const searchPathname = ugcSearchPathname(ugc);
        return searchPathname != null
          ? [
              `#${props.match.url}`,
              searchPathname,
              `results?${ugcSearchParams(ugc)}`,
            ].join('/')
          : null;
      }
    : null;

  return (
    <ClientContentCardProvider>
      <UgcLinkContext.Provider value={linkFn}>
        <UgcAssignmentProvider>
          <Page
            label="Reviews"
            routes={routes}
            landingRoute={'channels'}
            {...props}
          />
        </UgcAssignmentProvider>
      </UgcLinkContext.Provider>
    </ClientContentCardProvider>
  );
};

export default ReviewsIndex;



// WEBPACK FOOTER //
// ./src/pages/reviews/reviews.js